/* eslint-disable */

import moment from "moment-timezone";
import MetaDataService from "../services/MetaDataService";
import lodash from "lodash";
const DEFAULT_TIMEZONE = "Europe/Warsaw" as string;

//Truncate text to lenght and add '...'
const textElide = (text: string, length: number): string => {
	if (!text)
		return "";
	return text.length > length
		? text.slice(0, length) + "..."
		: text;
};

const toUtcDateString = (date: Date): string => {
	return moment(date).utc().format("YYYY-MM-DDTHH:mm:ss");
};


const toTimeZoneDateString = (date: Date, zone: string = "",
	truncateHours: boolean = false): string => {
	if (!zone) {
		const userTimezone = MetaDataService.getUserTimezone();
		zone = userTimezone ? userTimezone : DEFAULT_TIMEZONE;
	}
	const sourceDate = moment.utc(date, "YYYY-MM-DD HH:mm:ss");
	return sourceDate.clone().tz(zone).format(truncateHours ?
		"YYYY-MM-DD" :
		"YYYY-MM-DD HH:mm:ss");
};

//Check if user is mobile device
const isMobileDevice = (): boolean => {
	// //check max touch points
	// if ('maxTouchPoints' in navigator)
	//     return navigator.maxTouchPoints > 0 ? true : false

	// // For use within normal web clients
	// return navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i) != null;
	return window.matchMedia("(max-width: 576px)").matches;
};

//Check if component is available for all users.
//Now we dont support all features for turkish clients
const isComponentAvailable = (): boolean => {
	return (localStorage.getItem('lang') || "pl") != "tr";
};

/**
 * Get current locale from local storage
 * @returns
 */
const getCurrentLocale = (): string => {
	if (!localStorage.getItem("lang")) {
		return "en";
	}
	return localStorage.getItem("lang") ?? "en";
}

/**
 * Disable page scroll
 * @returns
 */
const disablePageScroll = () => {
	const scrollY = window.scrollY;
	document.body.classList.add('disable-pg-scroll');
	document.body.style.top = `-${scrollY}px`;
	document.body.dataset.scrollY = scrollY.toString();
}

/**
 * Enable page scroll
 * @returns
 */
const enablePageScroll = () => {
	const scrollY = document.body.dataset.scrollY;
	document.body.classList.remove('disable-pg-scroll');
	document.body.style.top = '';
	window.scrollTo(0, parseInt(scrollY || '0'));
}

/**
 * Add body overlay
 */
const addBodyOverlay = () => {
	const bodyElement = document.body;
	const existingOverlay = bodyElement.querySelector(".cm-body-menu-overlay");

	if (!existingOverlay) {
		const overlayElement = document.createElement("div");
		overlayElement.classList.add("cm-body-menu-overlay");
		bodyElement.appendChild(overlayElement);
	}
};

/**
 * Remove body overlay
 */
const removeBodyOverlay = () => {
	const bodyElement = document.body;
	const existingOverlay = bodyElement.querySelector(".cm-body-menu-overlay");

	if (existingOverlay) {
		bodyElement.removeChild(existingOverlay);
	}
};

const enableBackdropStyles = () => {
	addBodyOverlay();
	disablePageScroll();
}

const
	disableBackdropStyles = () => {
		removeBodyOverlay();
		enablePageScroll();
	}

const getRouteNameToDeviceByType = (deviceType) => {
	let _name = "device-details";
	//13 to licznik 3 fazowy, 16 to licznik modbus
	if (deviceType == 13 || deviceType == 16) {
		_name = "device-energy-details";
	} else if (deviceType == 10) {
		_name = "solar-device-details";
	} else if (deviceType == 17) {
		_name = "thermo-device-details";
	}
	return _name;
}


const setupSmartFixation = ({
	targetId,
	triggerId,
	margin = 16,
	fixedClass = 'fixed',
	hysteresisPx = 5,
}) => {
	const target = document.getElementById(targetId)
	const trigger = document.getElementById(triggerId)
	if (!target || !trigger) return () => { };

	// Get trigger bottom position - means total height
	const triggerHeight = trigger.getBoundingClientRect().bottom
	console.log("target", target.getBoundingClientRect());
	// Calculate the threshold for fixation
	const fixedThreshold = target.getBoundingClientRect().top - triggerHeight - margin
	console.log("toolbar", trigger.getBoundingClientRect());
	console.log("fixedThreshold", fixedThreshold);

	let isFixed = false

	function onScroll() {
		if (!target || !trigger) return

		const scrollY = window.scrollY || window.pageYOffset

		if (!isFixed && scrollY >= fixedThreshold) {
			target.classList.add(fixedClass)
			target.style.top = `${trigger.getBoundingClientRect().bottom + margin}px`;
			isFixed = true
		} else if (isFixed && scrollY < fixedThreshold) {
			target.classList.remove(fixedClass)
			target.style.top = '';
			isFixed = false
		}
	}

	window.addEventListener('scroll', onScroll)
	onScroll();
	return () => window.removeEventListener('scroll', onScroll);
}

//export all functions
export {
	textElide,
	toUtcDateString,
	toTimeZoneDateString,
	isMobileDevice,
	isComponentAvailable,
	getCurrentLocale,
	disablePageScroll,
	enablePageScroll,
	addBodyOverlay,
	removeBodyOverlay,
	enableBackdropStyles,
	disableBackdropStyles,
	getRouteNameToDeviceByType,
	setupSmartFixation
};